import { message, Modal, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { therapistColumns } from '../../Consts/TableColumns';
import { GetCertifiedOccupationalTherapistAssisstants } from '../../Services';
import { useColumnSearch } from '../ColumnSearchProps';

const COTATable = ({visibility, setVisibility, handleSubmit}) => {
    const [data, setData] = useState([]);
    const [highlighted, setHighlighted] = useState();
    const [loading, setLoading] = useState(true);
    const { getColumnSearchProps } = useColumnSearch();

    useEffect(() => {
        if(visibility){
            GetCertifiedOccupationalTherapistAssisstants().then((res) => {
                setData(res?.data);
                setHighlighted(res?.data[0]);
            }).catch(() => {
                message.error('Therapists not retrieved');
            }).finally(() => {
                setLoading(false);
            })
        }
    }, [visibility]);

    const handleRowOnClick = record => {
        setHighlighted(record);
    }

    const handleOnSubmit = () => {
        handleSubmit(highlighted);
        setVisibility(false);
    }

    return(
        <Modal
            title="COTAs"
            open={visibility}
            onCancel={() => setVisibility(false)}
            onOk={() => handleOnSubmit()}
        >
            <Table 
                pagination={{ hideOnSinglePage: true }}
                loading={loading}
                columns={therapistColumns(getColumnSearchProps)}
                dataSource={data}
                rowKey={(record) => record.id}
                rowClassName={record => (highlighted === record ? 'ant-table-row-selected' : '')}
                onRow={(record, rowIndex) => {
                    return {
                        onClick: () => handleRowOnClick(record)
                    }
                }}
            />
        </Modal>
    )
}

export default COTATable;